export var DONATION_ERROR;
(function (DONATION_ERROR) {
    DONATION_ERROR["EMPTY_DONATION"] = "EMPTY_DONATION";
    DONATION_ERROR["MINIMUM_NOT_REACHED"] = "MINIMUM_NOT_REACHED";
})(DONATION_ERROR || (DONATION_ERROR = {}));
